<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table :headers="headers" :items="getDataTable" :search="search" ref="dataTable">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>

        <template
          v-slot:item.dataCriacao="{ item }"
        >{{ $functions.formatDateFirebase(item.dataCriacao.seconds) }}</template>
        <template
          v-slot:item.dataProxContato="{ item }"
        >{{ $functions.formatDateFirebase(item.dataProxContato.seconds) }}</template>

        <template v-slot:item.status="{ item }">
          <v-btn
            outlined
            :color="colorsStatus[item.status]"
            rounded
            dark
            depressed
            small
            @click="hasAbility('Editar') ? $refs.dialogUpdateStatus.show(item) : ''"
          >{{ item.status }}</v-btn>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-tooltip bottom v-if="hasAbility('Movimentar')">
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogMovimentar.show(item)"
              >
                <v-icon>mdi-account-switch</v-icon>
              </v-btn>
            </template>
            Movimentar Lead
          </v-tooltip>
          <v-tooltip v-if="hasAbility('Editar')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogUpdateTermometro.show(item)"
              >
                <v-icon :color="colorsTermometro[item.termometro]">mdi-thermometer-lines</v-icon>
              </v-btn>
            </template>
            {{ item.termometro }}
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="transparent" small fab v-on="on" depressed @click="copyClipboard(item)">
                <v-icon>mdi-phone-settings</v-icon>
              </v-btn>
            </template>
            Copiar Nº Telefone
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogHistorico.show(item)"
              >
                <v-icon>mdi-history</v-icon>
              </v-btn>
            </template>
            Histórico do Lead
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogDetalhes.show(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            Detalhes
          </v-tooltip>
        </template>
      </v-data-table>

      <v-snackbar v-model="snackbar" color="success" :timeout="3000" :top="true">
        <span>Conteúdo copiado</span>
        <v-btn text @click="snackbar = false">Fechar</v-btn>
      </v-snackbar>
    </v-card-text>
    <DialogUpdateStatus ref="dialogUpdateStatus" @updated="update($event)" />
    <DialogMovimentar ref="dialogMovimentar" />
    <DialogUpdateTermometro ref="dialogUpdateTermometro" @updated="update($event)" />
    <DialogHistorico ref="dialogHistorico" />
    <DialogDetalhes ref="dialogDetalhes" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Table",

  props: {
    filter: {
      type: String,
      default: "Todas"
    }
  },

  components: {
    DialogUpdateStatus: () => import("./DialogUpdateStatus"),
    DialogMovimentar: () => import("../supervisor/components/DialogMovimentar"),
    DialogUpdateTermometro: () => import("./DialogUpdateTermometro"),
    DialogHistorico: () => import("./DialogHistorico"),
    DialogDetalhes: () => import("./DialogDetalhes")
  },

  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Celular", value: "celular" },
        { text: "Data Criação", value: "dataCriacao" },
        { text: "Data Prox. Contato", value: "dataProxContato" },
        { text: "Pagamento", value: "formaDePagamento" },
        { text: "Status", value: "status", align: "center" },
        { text: "Ações", value: "acoes", align: "center" }
      ],
      search: "",
      colorsStatus: {
        Andamento: "blue darken-2",
        Pendente: "orange darken-2",
        Sucesso: "green darken-2",
        Encerrado: "red darken-2"
      },
      colorsTermometro: {
        Frio: "blue",
        Morno: "orange lighten-2",
        Quente: "orange darken-1",
        SuperQuente: "orange darken-4"
      },
      snackbar: false
    };
  },

  computed: {
    ...mapGetters("leads", ["getLeads"]),
    ...mapGetters("leads", ["getAtrasadas"]),
    ...mapGetters("leads", ["getVenceAmanha"]),
    ...mapGetters("leads", ["getvenceHoje"]),

    getDataTable() {
      if (this.filter === "Todas") {
        return this.getLeads || [];
      } else if (this.filter === "Atrasadas") {
        return this.getAtrasadas || [];
      } else if (this.filter === "Vence Amanhã") {
        return this.getVenceAmanha || [];
      } else if (this.filter === "Vence Hoje") {
        return this.getvenceHoje || [];
      }
    }
  },

  methods: {
    copyClipboard(item) {
      let element = document.createElement("input");
      document.body.appendChild(element);
      element.value = item.celular;
      element.select();
      document.execCommand("copy");
      document.body.removeChild(element);
      this.snackbar = true;
    },

    update(lead) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === lead.id
      );
      this.$refs.dataTable.items[index].status = lead.status;
      this.$refs.dataTable.items[index].termometro = lead.termometro;
    },

    hasAbility(acesso) {
      return (
        this.$ability.can(acesso, "Leads Vendedor") ||
        this.$ability.can(acesso, "Leads Supervisor") ||
        this.$ability.can(acesso, "Leads Administrador") ||
        this.$ability.can(acesso, "Leads Administrativo")
      );
    }
  }
};
</script>
